import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const deleteUserAdminData = createAsyncThunk(
  "deleteUserAdmin",
  async (selectedUserAdmin) => {
    try {
      const response = await api.post(`${selectedUserAdmin}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting User Admin:", error);
      return error.response.data;
    }
  }
);

const DeleteUserAdminSlice = createSlice({
  name: "deleteUserAdmin",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteUserAdminData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteUserAdminData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(deleteUserAdminData.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default DeleteUserAdminSlice.reducer;
